import { ReactElement } from "react";
import { SenecAccordionProps } from "src/components/senec-accordion/SenecAccordion";
import { StyledBox } from "src/components/senec-accordion/SenecAccordionGroup.styled";

export interface AccordionGroupProps {
    children: ReactElement<SenecAccordionProps>[] | ReactElement<SenecAccordionProps>;
}

export const SenecAccordionGroup = ({ children }: { children: ReactElement<SenecAccordionProps>[] }) => {
    return <StyledBox>{children}</StyledBox>;
};
